/**
* Treatment Planning Tool CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Treatment Planning Tool CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'treatment-planning-tool-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.treatment-planning-tool-cta__splide' ).length ) {
        $( '.treatment-planning-tool-cta__splide' ).each( function( index, element ) {
          new Splide( element, {
            type: 'loop',
            direction: 'ttb',
            height: '100%',
            autoHeight: true,
            autoWidth: true,
            gap: '2.5rem',
            arrows: false,
            pagination: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            autoScroll: {
              speed: 0.2,
            },
          } ).mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'treatment-planning-tool-cta', COMPONENT );
} )( app );
